import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    courseOverview: JSON.parse(localStorage.getItem("course-overview") || "null"), // Khôi phục từ localStorage
};

export const courseOverviewSlice = createSlice({
    name: "courseOverview",
    initialState,
    reducers: {
        setCourseOverview: (state, action: PayloadAction) => {
            state.courseOverview = action.payload;
            localStorage.setItem("course-overview", JSON.stringify(action.payload)); // Lưu vào localStorage
        },
        clearCourseOverview: (state) => {
            state.courseOverview = null; // Xóa dữ liệu trong Redux
            localStorage.removeItem("course-overview"); // Xóa dữ liệu trong localStorag
        }
    }
})

export const { setCourseOverview, clearCourseOverview } = courseOverviewSlice.actions;
export default courseOverviewSlice.reducer;